import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { ToolbarConfig } from '@tencent/workbench';
import BETA_ICON from '@tencent/docs-design-resources/pc/svg/template_beta_16.svg';
import React from 'react';
import aiReviewIcon from '@src/img/ai-review.svg';


export const aiReviewConfig = {
    id: ActionType.AI_REVIEW,
    content: i18n.t('文本订正'),
    icon: aiReviewIcon,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: aiReviewConfig.id,
        style: {
            width: 'auto',
        },
        icon: <div>
            <img src={aiReviewConfig.icon} />
        </div>,
        text: aiReviewConfig.content,
        tooltip: aiReviewConfig.content,
    },
];
